export const form = {
  variants: {
    floating: {
      container: {
        label: {
          zIndex: 2,
          position: "absolute",
          backgroundColor: "white",
          pointerEvents: "none",
          mx: 3,
          px: 1,
          my: 2,
          transform: "scale(0.85) translateY(-24px)"
        }
      }
    }
  }
}
